"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareDates = void 0;
function compareDates(endDate) {
    const startDate = this.parent.startDate;
    return startDate < (endDate || 0);
}
exports.compareDates = compareDates;
